import { TTBackboneView } from '@/views/TTBackboneView';
import { TTAPI } from '@/services/TimeTrexClientAPI';

export class PortalResetForgotPasswordController extends TTBackboneView {
	constructor( options = {} ) {
		_.defaults( options, {
			events: {
				'click .portal-reset-forgot-password': 'resetForgotPassword',
				'click .close-reset-forgot-password': 'closeResetForgotPassword'
			}
		} );

		super( options );
	}

	initialize( options ) {
		super.initialize( options );
		if ( options.callback ) {
			this.callback = options.callback;
		}
		// var $this = this;
		// __non_webpack_require__( this._required_files, function() {
		this.api = TTAPI.APIRecruitmentAuthentication;
		var el = Global.loadWidget( 'views/portal/sign_in/PortalResetForgotPassword.html' );
		this.setElement( _.template( el )() );
		this.render();
		// } );
	}

	render() {
		var $this = this;
		this.$( '#new_password' ).focus();
		this.$( '#confirm_password' ).unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				$this.resetForgotPassword();
			}
		} );
		$( 'body' ).append( this.$el );

		const modal = new bootstrap.Modal(this.$el[0], {
			backdrop: 'static',
		});
		modal.show();

		$this.$el[0].addEventListener('hidden.bs.modal', function (event) {
			$this.removeView();
		});
	}

	removeView() {
		this.$el.remove();
		LocalCacheData.setAllURLArgs( _.omit( LocalCacheData.getAllURLArgs(), 'sm' ) );
		LocalCacheData.setAllURLArgs( _.omit( LocalCacheData.getAllURLArgs(), 'key' ) );

		var url = Global.getBaseURL( null, true, true ).replace(/#!m=.*?(&|$)/g, '#!m=PortalJobVacancy$1').replace( Global.getBaseURL( null, true, false ), '' ); //Be sure to include any other URL args.
		IndexViewController.instance.router.navigate( url, {
			trigger: false,
			replace: true
		} );
	}

	resetForgotPassword() {
		var $this = this;
		if ( this.getPassword() ) {
			var password = this.getPassword();
			this.api.passwordReset( LocalCacheData.getAllURLArgs().key,
				password.new_password,
				password.confirm_password
				, {
					onResult: function( result ) {
						if ( !result.isValid() ) {
							var details = result.getDetails();
							if ( !details ) {
								details = result.getDescription(); // If the details is empty, try to get description to show.
							}
							var error_string = '';
							if ( Global.isArray( details ) || typeof details === 'object' ) {
								$.each( details, function( index, val ) {
									if ( val.hasOwnProperty( 'error' ) ) {
										val = val.error;
									}
									var i = 0;
									for ( var key in val ) {
										error_string = error_string + val[key];
										if ( i > 0 ) {
											error_string += '<br>';
										}
										i++;
									}
								} );
							} else {
								error_string = details;
							}
							$this.setError( $this.$( '#new_password' ), error_string );
						} else {
							bootstrap.Modal.getInstance( $this.$el[0] ).hide();
							if ( $this.callback ) {
								$this.callback();
							}
						}

					}
				} );
		}
	}

	closeResetForgotPassword() {
		bootstrap.Modal.getInstance( this.$el[0] ).hide();
	}

	getPassword() {
		var new_password = this.$( '#new_password' );
		var confirm_password = this.$( '#confirm_password' );
		if ( !new_password.val() ) {
			this.setError( new_password, $.i18n._( 'New password can\'t be empty' ) );
			return false;
		} else {
			this.clearError( new_password );
		}
		if ( new_password.val() !== confirm_password.val() ) {
			this.setError( confirm_password, $.i18n._( 'New password does not match' ) );
			return false;
		} else {
			this.clearError( confirm_password );
		}

		return {
			new_password: new_password.val(),
			confirm_password: confirm_password.val()
		};
	}

	setError( widget, message ) {
		widget.css( 'border', '1px solid red' );

		const tooltip = new bootstrap.Tooltip( widget[0], {
			title: message
		} );

		tooltip.show();
	}

	clearError( widget ) {
		widget.css( 'border', '1px solid #ccc' );
		const tooltip = new bootstrap.Tooltip( widget[0] );

		if ( tooltip ) {
			tooltip.hide();
		}
	}

}